import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDiagnosticsByIds } from "@/hooks/diagnostic/useDiagnosticsByIds";

export function FaultNameCell(props: GridRenderCellParams) {
  const { t } = useTranslation();
  const { data: diagnostics } = useDiagnosticsByIds([props.row?.diagnostic?.id]);
  const diagnostic = diagnostics?.[props.row?.diagnostic?.id];
  return (
    <Tooltip
      sx={{ m: "auto" }}
      title={t("diagnosticEdit.source") + ":  " + (diagnostic?.source ?? "N/A")}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {diagnostic?.name || "---"}
      </Box>
    </Tooltip>
  );
}
